import React , {useState} from 'react'
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../../../StyleSheet/AppComponent/InputFields/InputFields.scss";

const Password = (props) => {
    const {value ,onChange , Error , label ,autoCompleted} = props;
    const [viewpass, setViewpass] = useState(false);
        console.log(autoCompleted ,"autoCompleted dsofi");

    return (
        <>
            <div className='Outer-Inputs'>
              
                <label >{label}</label>
                <div className='Password inputFields'>
                
                    <input
                    //  type='text' 
                                                  type={viewpass ? "text" : "password"} 

                     value={value} name="Password" onChange={onChange}
                     className={`${viewpass ? "activate" : "notactivate"}`} autoComplete={ autoCompleted ? autoCompleted :'off'}
                    />
                     <i className="icon">
                  {viewpass ? (
                    <RemoveRedEyeIcon 
                      onClick={(e) => setViewpass(!viewpass)}
                    ></RemoveRedEyeIcon>
                  ) : (
                    <VisibilityOffIcon
                      onClick={(e) => setViewpass(!viewpass)}
                    ></VisibilityOffIcon>
                  )}
                </i>
                </div>
                <p style={{color:"red", }}  className='Errors_list'>{Error}</p>
            </div>
        </>
    )
}

export default Password
